import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import { Container, Card, Button, Form } from "react-bootstrap";
import html2canvas from "html2canvas";


const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  // jpeg to pdf converter tool
  const [images, setImages] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setImages(files.map((file) => URL.createObjectURL(file)));
  };

  const convertToPdf = async () => {
    const doc = new jsPDF();
    for (let i = 0; i < images.length; i++) {
      const img = new Image();
      img.src = images[i];
      await new Promise((resolve) => {
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const imgData = canvas.toDataURL("image/jpeg");
          if (i > 0) doc.addPage();
          doc.addImage(imgData, "JPEG", 10, 10, 180, 160);
          resolve();
        };
      });
    }
    doc.save("converted.pdf");
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                JPEG to PDF Converter | Fast, Free & High-Quality
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

              
       <p className="text-dark">
          Converting JPEG to PDF is quick, easy, and efficient with the right tool. Whether you need to merge multiple images into a single PDF or convert a single JPEG file, an online JPEG to PDF converter provides a seamless experience. This process is essential for sharing images in a more professional, compact, and printable format. With a fast, free, and high-quality conversion tool, you can ensure your images retain their clarity without watermarks or downloads. Simply upload your JPEG files, adjust settings if needed, and convert them into a polished PDF instantly. Try it today for hassle-free file management!
        </p>
        <Form.Group controlId="fileInput" className="mb-3">
          <Form.Control type="file" multiple accept="image/jpeg" onChange={handleFileChange} />
        </Form.Group>
        <div id="preview" className="p-3 text-center">
          {images.map((src, index) => (
            <img key={index} src={src} alt={`preview-${index}`} className="img-fluid m-2"/>
          ))}
        </div>
        <Button onClick={convertToPdf} className="btn-primary mt-3">Convert to PDF</Button>
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
